<template>
    <div class="space-y-2">
        <div class="inline-flex items-center gap-2 rounded-md border border-blue-200 bg-blue-50 px-3 py-2">

            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="text-blue-600"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 21h6"/><path d="M9 21v-18l-6 6h18"/><path d="M9 3l10 6"/><path d="M17 9v4a2 2 0 1 1 -2 2"/></svg>

            <div class="text-sm">

                <p class="mb-0 font-medium text-blue-900">In Progress</p>

                <p v-if="totalSteps > 0" class="mb-0 text-xs text-blue-700">
                    {{ completedSteps }} of {{ totalSteps }} steps
                </p>

            </div>

        </div>

        <div v-if="totalSteps > 0" class="h-2 w-full rounded-full bg-gray-200">

            <div
                class="h-2 rounded-full bg-blue-600 transition-all"
                :style="{ width: `${percentage}%` }"
            ></div>

        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    completedSteps: {
        type: Number,
        required: true
    },
    totalSteps: {
        type: Number,
        required: true
    }
})

const percentage = computed(() => {
    if (props.totalSteps === 0) return 0
    return Math.round((props.completedSteps / props.totalSteps) * 100)
})
</script>